// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__BrfzF","title":"CardHeader_title__OChax"};